/* eslint eqeqeq: "off" */
import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row } from "antd";
import "./index.css";
import {
  AccountBookFilled,
  ProfileOutlined,
  // ProfileTwoTone,
} from "@ant-design/icons";
import Account from "./account";
import { FaRegQuestionCircle } from "react-icons/fa";
import AboutUsProgram from "../AboutProgram";
// import Rewards from "../../assets/images/rewards-1.png"
import FrequentAsked from "../FAQ";
import { RedeemOutlined } from "@mui/icons-material";
import { jwtDecode } from "jwt-decode";
import { useHistory } from "react-router";
import toast from "react-hot-toast";
function MyAccount() {
  const [activeKey, setActiveKey] = useState("My Account");
  const [rewardPoints, setRewardPoints] = useState("");
  const history = useHistory();
  const TabItems = [
    {
      key: "1",
      label: "My Account",
      icons: <AccountBookFilled />,
    },
    {
      key: "2",
      label: "About The Program",
      icons: <ProfileOutlined />,
    },
    {
      key: "2",
      label: "FAQ",
      icons: <FaRegQuestionCircle />,
    },
  ];

  const rewardsValue = (data) => {
    setRewardPoints(data);
  };

  return (
    <React.Fragment>
      {/* <Layout> */}
      <div>
        <MetaTags>
          <title>My Account | PMT</title>
        </MetaTags>

        <Row className="mb-10">
          <Col span={24} className="mt-[-20px]">
            <div className="my-account-image">{/* PMTC */}</div>
            {/* <Image preview={false} src={Rewards} width={100} /> */}
          </Col>
          <Col span={24} className="mt-[40px] my-account-tabs-section">
            <div className="flex rounded-lg">
              <div className="border border-1 w-[20%] h-[240px] p-2 rounded-sm my-account-tabs">
                <div>
                  {TabItems.map((tab) => (
                    <div
                      key={tab.key}
                      onClick={() => setActiveKey(tab.label)}
                      className={
                        activeKey === tab.label
                          ? "text-[13px] font-semibold input-login-label text-[#eb3e43] flex mb-2 bg-[#f1eeee] border-l-2 pt-2 pb-2 pl-2 border-[#eb3e43] pl-2 cursor-pointer hover:text-[#eb3e43]"
                          : "text-[13px] font-semibold input-login-label flex mb-2 cursor-pointer pt-2 pb-2 pl-2 hover:text-[#eb3e43]"
                      }
                    >
                      {/* <div className="mr-2">{tab.icons}</div> */}
                      <p>{tab.label}</p>
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => {
                    if (
                      rewardPoints !== "" &&
                      rewardPoints.availableRewardPoints !== "" &&
                      rewardPoints.availableRewardPoints > 0
                    ) {
                      history.push("/packages");
                    } else {
                      toast.error("You don't have a reward points to redeem");
                    }
                  }}
                  className={
                    "mt-[60px] flex text-[12px] bg-[#eb3e43] text-[white] cursor-pointer rounded-md hover:bg-[#e5272c] focus:bg-[#e5272c] pl-2 pr-2 pt-1 pb-1"
                  }
                >
                  <RedeemOutlined
                    style={{
                      fontSize: "16px",
                    }}
                    fontSize="20px"
                    className="mr-1"
                  />{" "}
                  <p className="mt-[1px]">Redeem</p>
                </div>
              </div>
              <div className="my-account-component-section font-label">
                {activeKey === "About The Program" ? (
                  <AboutUsProgram />
                ) : activeKey === "FAQ" ? (
                  <FrequentAsked mode={"Rewards"} />
                ) : (
                  <Account rewards={rewardsValue} />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default MyAccount;
